import api from "@/api/apiConfig"
import {
  Post,
  Get,
  Delete,
  Put
} from './base/baseAjax'

/*教育信息*/
let getEducate = (param) => {
  return Get({
    url: api.otherTable.getEducate,
    PathParam: param
  })
}
let addEducate = (param) => {
  return Post({
    url: api.otherTable.addEducate,
    bodyParam: param
  })
}
let delEducate = (param) => {
  return Delete({
    url: api.otherTable.delEducate,
    PathParam: param
  })
}
let editEducate = (param) => {
  return Put({
    url: api.otherTable.editEducate,
    bodyParam: param
  })
}
/*家庭成员*/
let getFamily = (param) => {
  return Get({
    url: api.otherTable.getFamily,
    PathParam: param
  })
}
let addFamily = (param) => {
  return Post({
    url: api.otherTable.addFamily,
    bodyParam: param
  })
}
let delFamily = (param) => {
  return Delete({
    url: api.otherTable.delFamily,
    PathParam: param
  })
}
let editFamily = (param) => {
  return Put({
    url: api.otherTable.editFamily,
    bodyParam: param
  })
}
/*工作经历*/
let getWork = (param) => {
  return Get({
    url: api.otherTable.getWork,
    PathParam: param
  })
}
let addWork = (param) => {
  return Post({
    url: api.otherTable.addWork,
    bodyParam: param
  })
}
let delWork = (param) => {
  return Delete({
    url: api.otherTable.delWork,
    PathParam: param
  })
}
let editWork = (param) => {
  return Put({
    url: api.otherTable.editWork,
    bodyParam: param
  })
}
/*劳动合同*/
let getContract = (param) => {
  return Get({
    url: api.otherTable.getContract,
    PathParam: param
  })
}
let addContract = (param) => {
  return Post({
    url: api.otherTable.addContract,
    bodyParam: param
  })
}
let delContract = (param) => {
  return Delete({
    url: api.otherTable.delContract,
    PathParam: param
  })
}
let cancelContract = (param) => {
  return Put({
    url: api.otherTable.cancelContract,
    bodyParam: param
  })
}
let editContract = (param) => {
  return Put({
    url: api.otherTable.editContract,
    bodyParam: param
  })
}
let getPrevTime = (param) => {
  return Get({
    url: api.otherTable.getPrevTime,
    PathParam: param
  })
}
let getEvaluate = (param) => {
  return Get({
    url: api.otherTable.getEvaluate,
    PathParam: param
  })
}
let addEvaluate = (param) => {
  return Post({
    url: api.otherTable.addEvaluate,
    bodyParam: param
  })
}
let editEvaluate = (param) => {
  return Put({
    url: api.otherTable.editEvaluate,
    bodyParam: param
  })
}

export default {
  getEducate,
  delEducate,
  editEducate,
  addEducate,
  getFamily,
  addFamily,
  delFamily,
  editFamily,
  getWork,
  addWork,
  delWork,
  editWork,
  getContract,
  addContract,
  delContract,
  cancelContract,
  editContract,
  getPrevTime,
  getEvaluate,
  addEvaluate,
  editEvaluate
}



// WEBPACK FOOTER //
// ./src/services/otherTable.js